import dayjs, { Dayjs } from "dayjs"

export class BroadcasterEvent {
  constructor(
    public canEntry: boolean,
    public constraints: any,
    public beginAt: Dayjs,
    public endAt: Dayjs,
  ) {}

  static fromObject(event: any): BroadcasterEvent {
    return new BroadcasterEvent(
      event.canEntry,
      event.constraints,
      dayjs(event.beginAt),
      dayjs(event.endAt),
    )
  }

  isUserRankEvent(): boolean {
    return this.constraints?.userRank
  }

  isDoing(now: Dayjs): boolean {
    return this.beginAt.unix() <= now.unix() && now.unix() < this.endAt.unix()
  }
}